var render = function render(){var _vm=this,_c=_vm._self._c;return _c('control-button',{attrs:{"styling":_vm.styled,"size":['md', 'lg-mac']},scopedSlots:_vm._u([{key:"append",fn:function(){return undefined},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }